import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from 'recharts';
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from '@/components/ui/chart';
import { t } from '@/i18n';
import type { DashboardUnpaidMonth } from '@ip/shared-types';
import { ChartCard } from './ChartCard';
import { MONTH_LABELS, formatAxis, monthKey, plnTooltipFormatter } from './chart-utils';

interface UnpaidChartProps {
  data: DashboardUnpaidMonth[];
  year: number;
}

export function UnpaidChart({ data, year }: UnpaidChartProps) {
  const chartData = MONTH_LABELS.map((label, i) => {
    const found = data.find((d) => d.month === monthKey(year, i));
    return {
      month: label,
      unpaid: found?.unpaidGross ?? 0,
      count: found?.unpaidCount ?? 0,
    };
  });

  const config: ChartConfig = {
    unpaid: { label: t('dashboard.unpaidByMonth'), color: 'var(--chart-3)' },
  };

  return (
    <ChartCard title={t('dashboard.unpaidByMonth')}>
      <ChartContainer config={config} className="h-[300px] w-full">
        <BarChart data={chartData}>
          <CartesianGrid vertical={false} strokeOpacity={0.4} />
          <XAxis dataKey="month" tickLine={false} axisLine={false} />
          <YAxis tickFormatter={formatAxis} tickLine={false} axisLine={false} width={64} />
          <ChartTooltip
            content={
              <ChartTooltipContent
                labelFormatter={(label) => `${label} ${year}`}
                formatter={plnTooltipFormatter(config)}
              />
            }
          />
          <Bar dataKey="unpaid" fill="var(--color-unpaid)" radius={[4, 4, 0, 0]} maxBarSize={28} />
        </BarChart>
      </ChartContainer>
    </ChartCard>
  );
}
